module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-update-stevedore/master-update-stevedore.component.scss
// module id = ./src/app/master/master-update-stevedore/master-update-stevedore.component.scss
// module chunks = main